import { BrowserRouter, Routes, Route } from "react-router-dom";
import { GoogleOAuthProvider } from '@react-oauth/google';
import { GOOGLE_LOGIN_BTN_CLIENT_ID } from "./global/components/Constants";

//Layout ================================
import Layout from "./global/components/Layout";

//GLOBAL ======================================
import Home from './global/Home';
import Contact from './global/Contact';
import Dashboard from "./global/Dashboard";
import PrivacyPolicy from "./global/PrivacyPolicy";

//USER ======================================
import Login from "./user/Login";
import Registration from "./user/Registration";
import ForgotPassword from "./user/ForgotPassword";
import ChangePassword from "./user/ChangePassword";
import AuthLogout from "./user/AuthLogout";

//TOPIC =====================================
import NewTopic from "./topic/NewTopic";
import EditTopic from "./topic/EditTopic";
import TopicSettings from "./topic/TopicSettings";
import TopicListing from "./topic/TopicListing";
import UserTopics from "./topic/UserTopics";
import TopicDetail from "./topic/TopicDetail";
import PresentationStart from "./topic/PresentationStart";
import Presentation from "./topic/Presentation";

//PROFILE =====================================
import CvEdit from "./profile/CvEdit";
import CvDetails from "./profile/CvDetails";

//JOB =====================================
import NewJobPost from "./job/NewJobPost";
import JobPostEdit from "./job/JobPostEdit";
import UserJobPosts from "./job/UserJobPosts";
import JobPostDetails from "./job/JobPostDetails";
import JobListing from "./job/JobListing";

function App() {
  const session = localStorage.getItem("session");

  return (
    <GoogleOAuthProvider clientId={GOOGLE_LOGIN_BTN_CLIENT_ID}>
    <BrowserRouter>
      <Routes>
      
      {/*GLOBAL ====================================*/}
      {/*Make the home page dashboard if user is login*/}
      {session &&
        <Route path="/" element={<Layout header={true} side={true} btn={false} footer={false} mode={"bright"}  />}>
          <Route index element={<Dashboard />}></Route>
        </Route>
      }
      {!session &&
        <Route path="/" element={<Layout header={true} side={false} btn={false} footer={true} mode={"bright"} />}>
          <Route index element={<Home />}></Route>
        </Route>
      }
      <Route path="/" element={<Layout header={true} side={true} btn={false} footer={false} mode={"bright"} />}>
        <Route exact path='/dashboard'  element={<Dashboard />}></Route>
      </Route>
      <Route path="/" element={<Layout header={true} side={false} btn={false} footer={true} mode={"bright"} />}>
        <Route exact path='/contact' element={<Contact />}></Route>
        <Route exact path='/privacy-policy' element={<PrivacyPolicy />}></Route>
      </Route>
      

      <Route path="/" element={<Layout header={true} side={false} btn={false} footer={true} mode={"bright"} />}>
        <Route exact path='/user/sign-in/:entry/' element={<Login />}></Route>
        <Route exact path='/user/sign-up/:entry/' element={<Registration />}></Route>
        <Route exact path='/user/forgot-password' element={<ForgotPassword />}></Route>
        <Route exact path='/user/change-password'  element={<ChangePassword />}></Route>
      </Route>
      <Route exact path='/user/logout' element={<AuthLogout />}></Route>

      {/*TOPIC ==============================*/}
      <Route path="/" element={<Layout header={true} side={true} btn={false} footer={false} mode={"bright"} />}>
        <Route exact path='/topics/me'  element={<UserTopics />}></Route>
        <Route exact path='/topic/new'  element={<NewTopic />}></Route>
        <Route exact path='/topic/edit/:code'  element={<EditTopic />}></Route>
        <Route exact path='/topic/settings/:code'  element={<TopicSettings />}></Route>
      </Route>
      <Route path="/" element={<Layout header={true} side={false} btn={false} footer={false} mode={"bright"} />}>
        <Route exact path='/topic/list/:page'  element={<TopicListing />}></Route>
        <Route exact path='/topic/:code'  element={<TopicDetail />}></Route>
      </Route>
      <Route exact path='/topic/presentation-start/:code'  element={<PresentationStart />}></Route>
      <Route exact path='/topic/presentation/:code/:compSlug'  element={<Presentation />}></Route>

      {/*PROFILE ==============================*/}
      <Route path="/" element={<Layout header={true} side={true} btn={false} footer={false} mode={"bright"} />}>
        <Route exact path='/cv/me'  element={<CvEdit />}></Route>
      </Route>
      <Route path="/" element={<Layout header={true} side={false} btn={false} footer={false} mode={"bright"} />}>
        <Route exact path='/cv/:code'  element={<CvDetails />}></Route>
      </Route>

      {/*JOB ==============================*/}
      <Route path="/" element={<Layout header={true} side={true} btn={false} footer={false} mode={"bright"} />}>
        <Route exact path='/jobs/me'  element={<UserJobPosts />}></Route>
        <Route exact path='/job/new'  element={<NewJobPost />}></Route>
        <Route exact path='/job/edit/:code'  element={<JobPostEdit />}></Route>
      </Route>
      <Route path="/" element={<Layout header={true} side={false} btn={false} footer={false} mode={"bright"} />}>
        <Route exact path='/job/list/:page'  element={<JobListing />}></Route>
        <Route exact path='/job/:code'  element={<JobPostDetails />}></Route>
      </Route>

      </Routes>
    </BrowserRouter>
    </GoogleOAuthProvider>
  );
}

export default App;
